import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {  Params,  } from 'react-router-dom';
import { withRouter } from '../../../utils/withRouter';;

import { FollowUp as FollowUpModel } from '../../../models/entities/shipment/shipment';
import { userSelectors } from '../../../state/ducks/user/selectors';
import { userDetails } from '../../../state/ducks/users/users';
import { RootState } from '../../../state/store/store';
import FollowUp, { IFollowUpExtended } from './FollowUp';
import { MetaShipment } from '../../../state/ducks/shipments/shipments';
import followUpSelector from '../../../state/ducks/followUps/selectors';
import { userSettings } from '../../../models/entities/user';
type PathParams = {};

type Props = PathParams & {
    followUps: IFollowUpExtended[];
    metaShipments: MetaShipment[];
    getFollowUps: () => void;
    getMetaShipments: () => void;
    addNewFollowUp: (shipmentId: string, followUp: FollowUpModel) => Promise<void>;
    updateFollowUp: (shipmentId: string, followUp: FollowUpModel) => Promise<void>;
    updateFollowUpCompletionStatus: (shipmentId: string, followUpId: number, isCompleted: boolean) => Promise<void>;
    deleteFollowUp: (shipmentId: string, followUpId: number) => Promise<void>;
    users: userDetails[];
    showAllFollowUps: boolean;
    setShowAllFollowUps: (showAllFollowUps: boolean) => void;
    currentUserId: string;
    setLastVisitShipmentId: (shipmentId: string) => void;
    lastVisitShipmentId?: string;
    followupGridSettings?: userSettings;
};

const FollowUpConnected = ({
    metaShipments,
    getMetaShipments,
    getFollowUps,
    followUps,
    addNewFollowUp,
    updateFollowUpCompletionStatus,
    deleteFollowUp,
    updateFollowUp,
    users,
    showAllFollowUps,
    setShowAllFollowUps,
    currentUserId,
    setLastVisitShipmentId,
    lastVisitShipmentId,
    followupGridSettings
}: Props) => {
    useEffect(() => {
        getFollowUps();
        getMetaShipments();
    }, []);
    return (
        <FollowUp
            metaShipments={metaShipments}
            followUps={followUps}
            addNewFollowUp={addNewFollowUp}
            updateFollowUpCompletionStatus={updateFollowUpCompletionStatus}
            deleteFollowUp={deleteFollowUp}
            users={users}
            updateFollowUp={updateFollowUp}
            showAllFollowUps={showAllFollowUps}
            setShowAllFollowUps={setShowAllFollowUps}
            currentUserId={currentUserId}
            setLastVisitShipmentId={setLastVisitShipmentId}
            lastVisitShipmentId={lastVisitShipmentId}
            followupGridSettings={followupGridSettings}
        />
    );
};

const mapStateToProps = (state: RootState) => ({
    followUps: followUpSelector.filteredFollowUps(state),
    showAllFollowUps: state.followUps.showAllFollowUps,
    metaShipments: state.shipments.metaShipments,
    users: userSelectors.usersInSameNetworkIncludeSelf(state),
    currentUserId: state.user.userInfo.id,
    lastVisitShipmentId: state.followUps.lastVisitShipmentId,
    followupGridSettings: userSelectors.followupGridSettings(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    getFollowUps: () => dispatch.followUps.getFollowUps(),
    getMetaShipments: () => dispatch.shipments.fetchMetaShipments(),
    updateFollowUp: (shipmentId: string, followUp: FollowUpModel) => dispatch.followUps.updateFollowUp({ shipmentId, followUp }),
    addNewFollowUp: (shipmentId: string, followUp: FollowUpModel) => dispatch.followUps.addNewFollowUp({ shipmentId, followUp }),
    updateFollowUpCompletionStatus: (shipmentId: string, followUpId: number, isCompleted: boolean) =>
        dispatch.followUps.updateFollowUpCompletionStatus({ shipmentId, followUpId, isCompleted }),
    deleteFollowUp: (shipmentId: string, followUpId: number) => dispatch.followUps.deleteFollowUp({ shipmentId, followUpId }),
    setShowAllFollowUps: (showAllFollowUps: boolean) => dispatch.followUps.setShowAllFollowUps(showAllFollowUps),
    setLastVisitShipmentId: (shipmentId: string) => dispatch.followUps.setLastVisitShipmentId(shipmentId)
});

export default connect(mapStateToProps, mapDispatchToProps as any)(FollowUpConnected as any);
